module.exports = __webpack_public_path__ + "resources/img/img-hyper-frame-apache-02.566df8a5856c1044dd3a6def2263d3e5.png";